import Vue from 'vue'
import { installMessage } from "~/plugins/Notifications/VMsg/index.js";
installMessage(Vue, Vue.prototype.$notify);